import { render, staticRenderFns } from "./SalesOrderList.vue?vue&type=template&id=017623e4&"
import script from "./SalesOrderList.vue?vue&type=script&lang=js&"
export * from "./SalesOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports